<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" scrollable :mask="false" draggable class="insert_power_pop">
    <Spin size="small" v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>{{spinValue}}</div>
    </Spin>
    <div class="insert_name">
      <div class="font_style_set"><span style="color: red">*</span>角色名称:</div>
      <Input v-model="roleName" class="config_content" placeholder="请输入显示名称" title="显示名称"/>
    </div>
    <div class="power_text_area">
      <div class="font_style_set">技能组:</div>
      <Select v-model="queues" placeholder="请选择技能组" multiple :max-tag-count="2">
        <Option v-for="(option, index) in queueList" :value="option.id" :key="index">{{option.queueName}}</Option>
      </Select>
    </div>
    <div class="power_text_area">
      <div class="font_style_set">角色备注:</div>
      <Input v-model="roleDesc" type="textarea" :autosize="{minRows: 2,maxRows: 2}" class="config_content"/>
    </div>
    <div class="font_left_tree"><span style="color: red">*</span>操作权限:</div>
    <div class="left_tree">
      <ul id="roletree" class="ztree" style="width:100%;overflow:auto;height: 300px;"></ul>
    </div>
    <div slot="footer">
      <Button type="primary" class="submit_btn" @click="saveRoleInfo()">确认</Button>
      <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
import {
  publicFunClass
} from '@/components/js/PublicFunClass.js'

export default {
  name: 'InsertPowerPop',
  mixins: [publicFunClass],
  props: {
    showInsertPower: Boolean,
    searchId: String
  },
  data() {
    return {
      model: false,
      spinShow: true,
      title: '添加角色',
      queueList: [],
      spinValue: '正在保存中...',
      roleName: '',
      queues: [],
      roleId: '',
      roleDesc: '',
      configInfo: JSON.parse(localStorage.getItem('configInfo')),
      supportAI: localStorage.getItem('supportAI'),
      sysSupportChat:localStorage.getItem("sysSupportChat"),
      inspectTreeData: [
        {
          id: '4_' + 1,
          pid: '4_' + 0,
          name: '我的工作台'
        },
        {
          id: '4_' + 2,
          pid: '4_' + 1,
          name: '待回访客户'
        },
        {
          id: '4_2-' + 1,
          pid: '4_' + 2,
          name: '批量删除'
        },
        {
          id: '4_2-' + 2,
          pid: '4_' + 2,
          name: '删除'
        },
        {
          id: '4_' + 3,
          pid: '4_' + 1,
          name: '待回收客户'
        },
        {
          id: '4_' + 5,
          pid: '4_' + 1,
          name: '待呼叫'
        },
        {
          id: '1_' + 3,
          pid: '1_' + 1,
          name: '公海客户'
        },
        {
          id: '1_3-' + 1,
          pid: '1_' + 3,
          name: '添加'
        },
        {
          id: '1_3-' + 2,
          pid: '1_' + 3,
          name: '导入'
        },
        {
          id: '1_3-' + 3,
          pid: '1_' + 3,
          name: '导出'
        },
        {
          id: '1_3-' + 4,
          pid: '1_' + 3,
          name: '分配'
        },
        {
          id: '1_3-' + 5,
          pid: '1_' + 3,
          name: '批量删除'
        },
        {
          id: '1_3-' + 6,
          pid: '1_' + 3,
          name: '申请客户'
        },
        {
          id: '1_3-' + 8,
          pid: '1_' + 3,
          name: '服务详情'
        },
        {
          id: '1_3-' + 9,
          pid: '1_' + 3,
          name: '编辑'
        },
        {
          id: '1_3-' + 10,
          pid: '1_' + 3,
          name: '删除'
        },
        {
          id: '1_3-' + 11,
          pid: '1_' + 3,
          name: '客户轨迹'
        },
        {
          id: '1_' + 1,
          pid: '1_' + 0,
          name: '客户管理'
        },
        {
          id: '1_' + 2,
          pid: '1_' + 1,
          name: '全部客户'
        },
        {
          id: '1_2-' + 1,
          pid: '1_' + 2,
          name: '添加'
        }, {
          id: '1_2-' + 2,
          pid: '1_' + 2,
          name: '导入'
        },
        {
          id: '1_2-' + 3,
          pid: '1_' + 2,
          name: '导出'
        },
        {
          id: '1_2-' + 4,
          pid: '1_' + 2,
          name: '分配'
        },
        {
          id: '1_2-' + 5,
          pid: '1_' + 2,
          name: '共享'
        },
        {
          id: '1_2-' + 6,
          pid: '1_' + 2,
          name: '批量删除'
        },
        {
          id: '1_2-' + 7,
          pid: '1_' + 2,
          name: '解除分配'
        },
        {
          id: '1_2-' + 8,
          pid: '1_' + 2,
          name: '转到公海'
        },
        {
          id: '1_2-' + 9,
          pid: '1_' + 2,
          name: '解除共享'
        },
        {
          id: '1_2-' + 10,
          pid: '1_' + 2,
          name: '放弃客户'
        },
        {
          id: '1_2-' + 11,
          pid: '1_' + 2,
          name: '短信群发'
        },
        {
          id: '1_2-' + 13,
          pid: '1_' + 2,
          name: '服务详情'
        },
        {
          id: '1_2-' + 14,
          pid: '1_' + 2,
          name: '编辑'
        },
        {
          id: '1_2-' + 15,
          pid: '1_' + 2,
          name: '删除'
        },
        {
          id: '1_2-' + 16,
          pid: '1_' + 2,
          name: '客户轨迹'
        },
        {
          id: '1_' + 5,
          pid: '1_' + 1,
          name: '服务记录'
        },
        {
          id: '1_5-' + 1,
          pid: '1_' + 5,
          name: '添加'
        },
        {
          id: '1_5-' + 2,
          pid: '1_' + 5,
          name: '导入'
        },
        {
          id: '1_5-' + 3,
          pid: '1_' + 5,
          name: '导出'
        },
        {
          id: '1_5-' + 4,
          pid: '1_' + 5,
          name: '批量删除'
        },
        {
          id: '1_5-' + 5,
          pid: '1_' + 5,
          name: '详情'
        },
        {
          id: '1_5-' + 6,
          pid: '1_' + 5,
          name: '编辑'
        },
        {
          id: '1_5-' + 7,
          pid: '1_' + 5,
          name: '删除'
        },
        /*add*/
        {
          id: '1_5-5-' + 1,
          pid: '1_5-' + 5,
          name: '播放'
        },
        {
          id: '1_5-5-' + 2,
          pid: '1_5-' + 5,
          name: '下载'
        },
        {
          id: '2_' + 1,
          pid: '2_' + 0,
          name: '呼出管理'
        },
        {
          id: '2_' + 2,
          pid: '2_' + 1,
          name: '呼出任务'
        },
        {
          id: '2_2-' + 1,
          pid: '2_' + 2,
          name: '编辑'
        },
        {
          id: '2_2-' + 2,
          pid: '2_' + 2,
          name: '删除'
        },
        {
          id: '2_2-' + 3,
          pid: '2_' + 2,
          name: '分配员工'
        },
        {
          id: '2_2-' + 4,
          pid: '2_' + 2,
          name: '添加'
        },
        {
          id: '2_2-' + 5,
          pid: '2_' + 2,
          name: '导入号码'
        },
        {
          id: '2_2-' + 7,
          pid: '2_' + 2,
          name: '启动'
        },
        {
          id: '2_2-' + 8,
          pid: '2_' + 2,
          name: '新建呼出任务'
        },{
          id: '2_2-' + 9,
          pid: '2_' + 2,
          name: '导出'
        },
        {
          id: '2_' + 3,
          pid: '2_' + 1,
          name: '呼出监控'
        },
        //add ai menu
        {
          id: 'a_' + 1,
          pid: 'a_' + 0,
          name: 'AI管理'
        },
        {
          id: 'a_' + 2,
          pid: 'a_' + 1,
          name: 'AI流程配置'
        },
        {
          id: 'a_2-' + 1,
          pid: 'a_' + 2,
          name: '添加'
        },
        {
          id: 'a_2-' + 2,
          pid: 'a_' + 2,
          name: '编辑'
        },
        {
          id: 'a_2-'+3,
          pid: 'a_'+2,
          name: '分类'
        },/*{id: 'a_2-'+4,pid: 'a_'+2,name: '测试流程'},*/
        {
          id: 'a_2-' + 5,
          pid: 'a_' + 2,
          name: '删除'
        },
        {
          id: 'a_2-' + 6,
          pid: 'a_' + 2,
          name: '复制流程'
        },
        {
          id: 'a_2-' + 8,
          pid: 'a_' + 2,
          name: '绘制流程'
        },
        {
          id: 'a_2-' + 9,
          pid: 'a_' + 2,
          name: '发布流程'
        },
        {
          id: 'a_' + 3,
          pid: 'a_' + 1,
          name: 'AI呼叫管理'
        },
        {
          id: 'a_3-' + 1,
          pid: 'a_' + 3,
          name: '添加'
        },
        {
          id: 'a_3-' + 2,
          pid: 'a_' + 3,
          name: '编辑'
        },
        {
          id: 'a_3-' + 3,
          pid: 'a_' + 3,
          name: '删除'
        },
        {
          id: 'a_3-' + 4,
          pid: 'a_' + 3,
          name: '导入号码'
        },
        {
          id: 'a_3-' + 6,
          pid: 'a_' + 3,
          name: '启动'
        },
        {
          id: 'a_' + 4,
          pid: 'a_' + 1,
          name: 'AI技能组'
        },
        {
          id: 'a_4-' + 1,
          pid: 'a_' + 4,
          name: '添加'
        },
        {
          id: 'a_4-' + 2,
          pid: 'a_' + 4,
          name: '编辑'
        },
        {
          id: 'a_4-' + 3,
          pid: 'a_' + 4,
          name: '删除'
        },
        {
          id: 'a_' + 5,
          pid: 'a_' + 1,
          name: 'AI通话记录'
        },
        {
          id: 'a_5-' + 1,
          pid: 'a_' + 5,
          name: '导出'
        },
        {
          id: 'a_5-' + 2,
          pid: 'a_' + 5,
          name: '下载'
        },
        {
          id: 'a_5-' + 3,
          pid: 'a_' + 5,
          name: '详情'
        },
        {
          id: 'a_5-' + 4,
          pid: 'a_' + 5,
          name: '播放'
        },
        {
          id: 'a_5-3-' + 1,
          pid: 'a_5-' + 3,
          name: '播放'
        },
        {
          id: 'a_5-3-' + 2,
          pid: 'a_5-' + 3,
          name: '下载'
        },
        //工单
        {
          id: 'b_1',
          pid: 'b_1',
          name: '工单管理'
        },{
          id: 'b_2',
          pid: 'b_1',
          name: '所有工单'
        },{
          id: 'b_2-1',
          pid: 'b_2',
          name: '新建工单'
        },
        {
          id: 'b_2-3',
          pid: 'b_2',
          name: '导出'
        },{
          id: 'b_2-4',
          pid: 'b_2',
          name: '批量删除'
        },

        {
          id: 'b_2-6',
          pid: 'b_2',
          name: '删除'
        },{
          id: 'b_2-5',
          pid: 'b_2',
          name: '详情'
        },{
          id: 'b_2-5-1',
          pid: 'b_2-5',
          name: '编辑工单属性'
        },{
          id: 'b_2-5-2',
          pid: 'b_2-5',
          name: '回复工单'
        },{
          id: 'b_2-5-3',
          pid: 'b_2-5',
          name: '暂停工单'
        },{
          id: 'b_2-5-4',
          pid: 'b_2-5',
          name: '处理完毕工单'
        },{
          id: 'b_2-5-5',
          pid: 'b_2-5',
          name: '审核工单'
        },{
          id: 'b_2-5-6',
          pid: 'b_2-5',
          name: '修改处理人'
        },{
          id: 'b_2-5-7',
          pid: 'b_2-5',
          name: '修改抄送人'
        },{
          id: 'b_2-5-8',
          pid: 'b_2-5',
          name: '重置工单'
        },{
          id: 'b_3',
          pid: 'b_1',
          name: '我的未完成工单'
        },{
          id: 'b_3-1',
          pid: 'b_3',
          name: '导出'
        },{
          id: 'b_3-2',
          pid: 'b_3',
          name: '删除'
        },{
          id: 'b_3-4',
          pid: 'b_3',
          name: '批量删除'
        },{
          id: 'b_3-3',
          pid: 'b_3',
          name: '详情'
        },{
          id: 'b_3-3-1',
          pid: 'b_3-3',
          name: '编辑工单属性'
        },{
          id: 'b_3-3-2',
          pid: 'b_3-3',
          name: '回复工单'
        },{
          id: 'b_3-3-3',
          pid: 'b_3-3',
          name: '暂停工单'
        },{
          id: 'b_3-3-4',
          pid: 'b_3-3',
          name: '处理完毕工单'
        },{
          id: 'b_3-3-6',
          pid: 'b_3-3',
          name: '修改处理人'
        },{
          id: 'b_3-3-7',
          pid: 'b_3-3',
          name: '修改抄送人'
        },{
          id: 'b_4',
          pid: 'b_1',
          name: '待我确认的工单'
        },{
          id: 'b_4-1',
          pid: 'b_4',
          name: '导出'
        },{
          id: 'b_4-2',
          pid: 'b_4',
          name: '删除'
        },{
          id: 'b_4-5',
          pid: 'b_4',
          name: '批量删除'
        },{
          id: 'b_4-4',
          pid: 'b_4',
          name: '详情'
        },{
          id: 'b_4-4-1',
          pid: 'b_4-4',
          name: '编辑工单属性'
        },{
          id: 'b_4-4-2',
          pid: 'b_4-4',
          name: '回复工单'
        },{
          id: 'b_4-4-3',
          pid: 'b_4-4',
          name: '暂停工单'
        },{
          id: 'b_4-4-4',
          pid: 'b_4-4',
          name: '处理完毕工单'
        },{
          id: 'b_4-4-6',
          pid: 'b_4-4',
          name: '修改处理人'
        },{
          id: 'b_4-4-7',
          pid: 'b_4-4',
          name: '修改抄送人'
        },{
          id: 'b_5',
          pid: 'b_1',
          name: '抄送给我的工单'
        },{
          id: 'b_5-1',
          pid: 'b_5',
          name: '导出'
        },{
          id: 'b_5-2',
          pid: 'b_5',
          name: '删除'
        },{
          id: 'b_5-4',
          pid: 'b_5',
          name: '批量删除'
        },{
          id: 'b_5-3',
          pid: 'b_5',
          name: '详情'
        },{
          id: 'b_5-3-1',
          pid: 'b_5-3',
          name: '编辑工单属性'
        },{
          id: 'b_5-3-2',
          pid: 'b_5-3',
          name: '回复工单'
        },{
          id: 'b_5-3-3',
          pid: 'b_5-3',
          name: '暂停工单'
        },{
          id: 'b_5-3-4',
          pid: 'b_5-3',
          name: '处理完毕工单'
        },{
          id: 'b_5-3-6',
          pid: 'b_5-3',
          name: '修改处理人'
        },{
          id: 'b_5-3-7',
          pid: 'b_5-3',
          name: '修改抄送人'
        },{
          id: 'b_5-3-8',
          pid: 'b_5-3',
          name: '重置工单'
        },{
          id: 'b_6',
          pid: 'b_1',
          name: '我创建的工单'
        },{
          id: 'b_6-1',
          pid: 'b_6',
          name: '导出'
        },{
          id: 'b_6-2',
          pid: 'b_6',
          name: '删除'
        },{
          id: 'b_6-4',
          pid: 'b_6',
          name: '批量删除'
        },{
          id: 'b_6-3',
          pid: 'b_6',
          name: '详情'
        },{
          id: 'b_6-3-1',
          pid: 'b_6-3',
          name: '编辑工单属性'
        },{
          id: 'b_6-3-2',
          pid: 'b_6-3',
          name: '回复工单'
        },{
          id: 'b_6-3-3',
          pid: 'b_6-3',
          name: '暂停工单'
        },{
          id: 'b_6-3-4',
          pid: 'b_6-3',
          name: '处理完毕工单'
        },{
          id: 'b_6-3-5',
          pid: 'b_6-3',
          name: '审核工单'
        },{
          id: 'b_6-3-6',
          pid: 'b_6-3',
          name: '修改处理人'
        },{
          id: 'b_6-3-7',
          pid: 'b_6-3',
          name: '修改抄送人'
        },{
          id: 'b_6-3-8',
          pid: 'b_6-3',
          name: '重置工单'
        },{
          id: 'b_7',
          pid: 'b_1',
          name: '未分配的工单'
        },{
          id: 'b_7-1',
          pid: 'b_7',
          name: '导出'
        },{
          id: 'b_7-2',
          pid: 'b_7',
          name: '删除'
        },{
          id: 'b_7-6',
          pid: 'b_7',
          name: '批量删除'
        },{
          id: 'b_7-5',
          pid: 'b_7',
          name: '详情'
        },{
          id: 'b_7-5-1',
          pid: 'b_7-5',
          name: '编辑工单属性'
        },{
          id: 'b_7-5-2',
          pid: 'b_7-5',
          name: '回复工单'
        },{
          id: 'b_7-5-3',
          pid: 'b_7-5',
          name: '暂停工单'
        },{
          id: 'b_7-5-4',
          pid: 'b_7-5',
          name: '处理完毕工单'
        },{
          id: 'b_7-5-6',
          pid: 'b_7-5',
          name: '修改处理人'
        },{
          id: 'b_7-5-7',
          pid: 'b_7-5',
          name: '修改抄送人'
        },{
          id: 'b_8',
          pid: 'b_1',
          name: '已分配的工单'
        },{
          id: 'b_8-1',
          pid: 'b_8',
          name: '导出'
        },{
          id: 'b_8-2',
          pid: 'b_8',
          name: '删除'
        },{
          id: 'b_8-5',
          pid: 'b_8',
          name: '批量删除'
        },{
          id: 'b_8-4',
          pid: 'b_8',
          name: '详情'
        },{
          id: 'b_8-4-1',
          pid: 'b_8-4',
          name: '编辑工单属性'
        },{
          id: 'b_8-4-2',
          pid: 'b_8-4',
          name: '回复工单'
        },{
          id: 'b_8-4-3',
          pid: 'b_8-4',
          name: '暂停工单'
        },{
          id: 'b_8-4-4',
          pid: 'b_8-4',
          name: '处理完毕工单'
        },{
          id: 'b_8-4-6',
          pid: 'b_8-4',
          name: '修改处理人'
        },{
          id: 'b_8-4-7',
          pid: 'b_8-4',
          name: '修改抄送人'
        },{
          id: 'b_9',
          pid: 'b_1',
          name: '处理中的工单'
        },{
          id: 'b_9-1',
          pid: 'b_9',
          name: '导出'
        },{
          id: 'b_9-2',
          pid: 'b_9',
          name: '删除'
        },{
          id: 'b_9-6',
          pid: 'b_9',
          name: '批量删除'
        },{
          id: 'b_9-5',
          pid: 'b_9',
          name: '详情'
        },{
          id: 'b_9-5-1',
          pid: 'b_9-5',
          name: '编辑工单属性'
        },{
          id: 'b_9-5-2',
          pid: 'b_9-5',
          name: '回复工单'
        },{
          id: 'b_9-5-3',
          pid: 'b_9-5',
          name: '暂停工单'
        },{
          id: 'b_9-5-4',
          pid: 'b_9-5',
          name: '处理完毕工单'
        },{
          id: 'b_9-5-6',
          pid: 'b_9-5',
          name: '修改处理人'
        },{
          id: 'b_9-5-7',
          pid: 'b_9-5',
          name: '修改抄送人'
        },{
          id: 'b_a',
          pid: 'b_1',
          name: '暂停的工单'
        },{
          id: 'b_a-1',
          pid: 'b_a',
          name: '导出'
        },{
          id: 'b_a-2',
          pid: 'b_a',
          name: '删除'
        },{
          id: 'b_a-4',
          pid: 'b_a',
          name: '批量删除'
        },{
          id: 'b_a-3',
          pid: 'b_a',
          name: '详情'
        },{
          id: 'b_a-3-1',
          pid: 'b_a-3',
          name: '编辑工单属性'
        },{
          id: 'b_a-3-2',
          pid: 'b_a-3',
          name: '回复工单'
        },{
          id: 'b_a-3-4',
          pid: 'b_a-3',
          name: '处理完毕工单'
        },{
          id: 'b_a-3-6',
          pid: 'b_a-3',
          name: '修改处理人'
        },{
          id: 'b_a-3-7',
          pid: 'b_a-3',
          name: '修改抄送人'
        },{
          id: 'b_b',
          pid: 'b_1',
          name: '已完成的工单'
        },{
          id: 'b_b-1',
          pid: 'b_b',
          name: '导出'
        },{
          id: 'b_b-2',
          pid: 'b_b',
          name: '删除'
        },{
          id: 'b_b-6',
          pid: 'b_b',
          name: '批量删除'
        },{
          id: 'b_b-5',
          pid: 'b_b',
          name: '详情'
        },{
          id: 'b_b-5-1',
          pid: 'b_b-5',
          name: '编辑工单属性'
        },{
          id: 'b_b-5-5',
          pid: 'b_b-5',
          name: '审核工单'
        },{
          id: 'b_b-5-8',
          pid: 'b_b-5',
          name: '重置工单'
        },{
          id: 'b_c',
          pid: 'b_1',
          name: '已关闭的工单'
        },{
          id: 'b_c-1',
          pid: 'b_c',
          name: '导出'
        },{
          id: 'b_c-2',
          pid: 'b_c',
          name: '删除'
        },{
          id: 'b_c-4',
          pid: 'b_c',
          name: '批量删除'
        },{
          id: 'b_c-3',
          pid: 'b_c',
          name: '详情'
        },{
          id: 'b_d',
          pid: 'b_1',
          name: '回收站'
        },{
          id: 'b_d-1',
          pid: 'b_d',
          name: '还原'

        },{
          id: 'b_d-2',
          pid: 'b_d',
          name: '删除'

        },{
          id: 'b_d-3',
          pid: 'b_d',
          name: '批量还原'

        },{
          id: 'b_d-4',
          pid: 'b_d',
          name: '批量删除'
        },{
          id: 'b_d-5',
          pid: 'b_d',
          name: '导出'
        },{
          id: 'b_d-6',
          pid: 'b_d',
          name: '详情'
        },
        {
          id: '5_' + 1,
          pid: '5_' + 0,
          name: '短信管理'
        },
        {
          id: '5_' + 2,
          pid: '5_' + 1,
          name: '短信发送'
        },
        {
          id: '5_' + 3,
          pid: '5_' + 1,
          name: '短信模板'
        }, {
          id: '5_3-' + 1,
          pid: '5_3',
          name: '添加'
        }, {
          id: '5_3-' + 2,
          pid: '5_3',
          name: '编辑'
        }, {
          id: '5_3-' + 3,
          pid: '5_3',
          name: '删除'
        },
        {
          id: '5_' + 4,
          pid: '5_' + 1,
          name: '短信记录'
        }, {
          id: '5_4-' + 1,
          pid: '5_' + 4,
          name: '导出'
        },
        {
          id: '6_' + 1,
          pid: '6_' + 0,
          name: '知识库管理'
        },
        {
          id: '6_' + 2,
          pid: '6_' + 1,
          name: '知识总览'
        }, {
          id: '6_2-' + 1,
          pid: '6_' + 2,
          name: '编辑类目'
        }, {
          id: '6_2-' + 2,
          pid: '6_' + 2,
          name: '删除类目'
        }, {
          id: '6_2-' + 3,
          pid: '6_' + 2,
          name: '添加类目'
        }, {
          id: '6_2-' + 4,
          pid: '6_' + 2,
          name: '查看'
        }, {
          id: '6_2-' + 5,
          pid: '6_' + 2,
          name: '编辑'
        }, {
          id: '6_2-' + 6,
          pid: '6_' + 2,
          name: '删除'
        }, {
          id: '6_2-' + 7,
          pid: '6_' + 2,
          name: '添加'
        },

        {
          id: '7_' + 1,
          pid: '7_' + 0,
          name: '监控管理'
        },
        {
          id: '7_' + 2,
          pid: '7_' + 1,
          name: '通话监控'
        },
        {
          id: '7_2-' + 1,
          pid: '7_' + 2,
          name: '当前通话'
        },
        {
          id: '7_2-' + 2,
          pid: '7_' + 2,
          name: '总览'
        },
        {
          id: '7_2-' + 3,
          pid: '7_' + 2,
          name: '技能组监控'
        },
        {
          id: '7_2-' + 4,
          pid: '7_' + 2,
          name: '座席监控'
        },
        // 未完成工单监控
        {
          id: '7_3',
          pid: '7_1',
          name: '未完成工单监控'
        },
        {
          id: '7_3-' + 1,
          pid: '7_3',
          name: '详情'
        },{
          id: '7_3-1-1',
          pid: '7_3-1',
          name: '编辑工单属性'
        },{
          id: '7_3-1-2',
          pid: '7_3-1',
          name: '回复工单'
        },{
          id: '7_3-1-3',
          pid: '7_3-1',
          name: '暂停工单'
        },{
          id: '7_3-1-4',
          pid: '7_3-1',
          name: '处理完毕工单'
        },{
          id: '7_3-1-6',
          pid: '7_3-1',
          name: '修改处理人'
        },{
          id: '7_3-1-7',
          pid: '7_3-1',
          name: '修改抄送人'
        },
        {
          id: '8_' + 1,
          pid: '8_' + 0,
          name: '统计报表'
        },
        {
          id: '8_' + 2,
          pid: '8_' + 1,
          name: '明细报表'
        },

        {
          id: '8_2-' + 1,
          pid: '8_' + 2,
          name: '通话记录'
        },
        {
          id: '8_2-1-' + 1,
          pid: '8_2-' + 1,
          name: '导出'
        },
        {
          id: '8_2-1-' + 5,
          pid: '8_2-' + 1,
          name: '录音批量下载'
        },
        /*add*/
        {
          id: '8_2-1-' + 2,
          pid: '8_2-' + 1,
          name: '播放'
        },
        {
          id: '8_2-1-' + 3,
          pid: '8_2-' + 1,
          name: '下载'
        },
        {
          id: '8_2-1-' + 4,
          pid: '8_2-' + 1,
          name: '详情'
        },
        {
          id: '8_2-1-' + 6,
          pid: '8_2-' + 1,
          name: '备注'
        },
        {
          id: '8_2-1-4-' + 1,
          pid: '8_2-1-' + 4,
          name: '播放'
        },
        {
          id: '8_2-1-4-' + 2,
          pid: '8_2-1-' + 4,
          name: '下载'
        },
        /*end*/
        {
          id: '8_2-' + 2,
          pid: '8_' + 2,
          name: '状态变化明细'
        },
        {
          id: '8_2-2-' + 1,
          pid: '8_2-' + 2,
          name: '导出'
        },
        {
          id: '8_2-' + 3,
          pid: '8_' + 2,
          name: '满意度明细'
        },
        {
          id: '8_2-3-' + 1,
          pid: '8_2-' + 3,
          name: '导出'
        },
        {
          id: '8_2-' + 4,
          pid: '8_' + 2,
          name: '未接来电'
        },
        {
          id: '8_2-4-' + 1,
          pid: '8_2-' + 4,
          name: '导出'
        },
        {
          id: '8_2-' + 5,
          pid: '8_' + 2,
          name: '内线通话明细'
        },
        {
          id: '8_2-5-' + 1,
          pid: '8_2-' + 5,
          name: '导出'
        },
        /*add*/
        {
          id: '8_2-5-' + 2,
          pid: '8_2-' + 5,
          name: '播放'
        },
        {
          id: '8_2-5-' + 3,
          pid: '8_2-' + 5,
          name: '下载'
        },
        /*end*/
        {
          id: '8_2-' + 7,
          pid: '8_' + 2,
          name: '语音留言'
        },
        {
          id: '8_2-7-' + 1,
          pid: '8_2-' + 7,
          name: '导出'
        },
        /*add*/
        {
          id: '8_2-7-' + 2,
          pid: '8_2-' + 7,
          name: '播放'
        },
        {
          id: '8_2-7-' + 3,
          pid: '8_2-' + 7,
          name: '下载'
        },
        /*end*/
        {
          id: '8_2-' + 6,
          pid: '8_' + 2,
          name: '办公话单'
        },
        {
          id: '8_2-6-' + 1,
          pid: '8_2-' + 6,
          name: '导出'
        },
        /*add*/
        {
          id: '8_2-6-' + 2,
          pid: '8_2-' + 6,
          name: '播放'
        },
        {
          id: '8_2-6-' + 3,
          pid: '8_2-' + 6,
          name: '下载'
        },

        {
          id: '8_2-' + 8,
          pid: '8_' + 2,
          name: '未推送话单'
        },
        {
          id: '8_2-8-' + 1,
          pid: '8_2-' + 8,
          name: '批量推送'
        },
        {
           id: '8_2-8-' + 2,
          pid: '8_2-' + 8,
          name: '推送'
        },
        {
           id: '8_2-8-' + 3,
          pid: '8_2-' + 8,
          name: '查看日志'
        },
        {
          id: '8_2-' +9,
          pid: '8_' + 2,
          name: '会话明细'
        },
        {
          id: '8_2-9-' +1,
          pid: '8_2-' + 9,
          name: '导出'
        },
        {
          id: '8_2-9-' +2,
          pid: '8_2-' + 9,
          name: '详情'
        },
        {
          id: '8_2-' +10,
          pid: '8_' + 2,
          name: '会话留言'
        },
        {
          id: '8_2-10-' +1,
          pid: '8_2-' + 10,
          name: '导出'
        },
        {
          id: '8_2-10-' +2,
          pid: '8_2-' + 10,
          name: '分配'
        },
        {
          id: '8_2-10-' +3,
          pid: '8_2-' + 10,
          name: '解除分配'
        },
        {
          id: '8_2-10-' +4,
          pid: '8_2-' + 10,
          name: '批量删除'
        },
         {
          id: '8_2-10-' +5,
          pid: '8_2-' + 10,
          name: '处理'
        },
         {
          id: '8_2-10-' +6,
          pid: '8_2-' + 10,
          name: '删除'
        },
        {
          id: '8_2-10-' +7,
          pid: '8_2-' + 10,
          name: '批量处理'
        },
        /*end*/
        {
          id: '8_' + 3,
          pid: '8_' + 1,
          name: '通话统计'
        },
        {
          id: '8_3-' + 1,
          pid: '8_' + 3,
          name: '通话总览'
        },
        {
          id: '8_3-1-' + 1,
          pid: '8_3-' + 1,
          name: '导出'
        },
        {
          id: '8_3-' + 2,
          pid: '8_' + 3,
          name: '热线号码统计'
        },
        {
          id: '8_3-2-' + 1,
          pid: '8_3-' + 2,
          name: '导出'
        },
        {
          id: '8_3-' + 3,
          pid: '8_' + 3,
          name: '座席通话统计'
        },
        {
          id: '8_3-3-' + 1,
          pid: '8_3-' + 3,
          name: '导出'
        },
        {
          id: '8_3-' + 4,
          pid: '8_' + 3,
          name: '技能组通话统计'
        },
        {
          id: '8_3-4-' + 1,
          pid: '8_3-' + 4,
          name: '导出'
        },
        {
          id: '8_3-' + 5,
          pid: '8_' + 3,
          name: '部门通话统计'
        },
        {
          id: '8_3-5-' + 1,
          pid: '8_3-' + 5,
          name: '导出'
        },
        {
          id: '8_3-' + 6,
          pid: '8_' + 3,
          name: 'IVR统计'
        },
        {
          id: '8_3-6-' + 1,
          pid: '8_3-' + 6,
          name: '导出'
        },
        {
          id: '8_3-' + 7,
          pid: '8_' + 3,
          name: '满意度统计'
        },
        {
          id: '8_3-7-' + 1,
          pid: '8_3-' + 7,
          name: '导出'
        },
        {
          id: '8_' + 4,
          pid: '8_' + 1,
          name: '图形报表'
        },
        {
          id: '8_4-' + 1,
          pid: '8_' + 4,
          name: '座席通话量'
        },
        {
          id: '8_4-' + 2,
          pid: '8_' + 4,
          name: '技能组通话量'
        },
        {
          id: '8_4-' + 3,
          pid: '8_' + 4,
          name: '部门通话量'
        },
        {
          id: '8_4-' + 4,
          pid: '8_' + 4,
          name: '满意度评价'
        },
        {
          id:'8_'+6,
          pid:'8_'+1,
          name:'AI图形报表'
        },
        {
          id:'8_6-'+1,
          pid:'8_'+6,
          name:'交互轮次统计'
        },
        {
          id:'8_6-'+2,
          pid:'8_'+6,
          name:'呼出质量统计'
        },
        {
          id:'8_6-'+3,
          pid:'8_'+6,
          name:'关注点统计'
        },
        {
          id:'8_6-'+4,
          pid:'8_'+6,
          name:'分类标签统计'
        },// 工单统计
        {
          id: '8_7',
          pid: '8_1',
          name: '工单统计'
        },{
          id: '8_7-2',
          pid: '8_7',
          name: '客服工作量统计'
        },{
          id: '8_7-2-1',
          pid: '8_7-2',
          name: '导出'
        },{
          id: '8_7-3',
          pid: '8_7',
          name: '工单类型统计'
        },{
          id: '8_7-3-1',
          pid: '8_7-3',
          name: '导出'
        }
        // ,{
        //   id: '8_7-4',
        //   pid: '8_7',
        //   name: '工单满意度统计'
        // }
        ,{
          id: '8_7-5',
          pid: '8_7',
          name: 'SLA服务等级统计'
        },{
          id: '8_7-5-1',
          pid: '8_7-5',
          name: '导出'
        },
        {
          id: '8_' + 5,
          pid: '8_' + 1,
          name: '大屏展示'
        },
        {
          id: '8_5-' + 1,
          pid: '8_' + 5,
          name: '通话总览'
        }, {
          id: '8_5-' + 2,
          pid: '8_' + 5,
          name: '座席职场'
        },
        {
          id: '10_' + 1,
          pid: '10_' + 0,
          name: '快速应用'
        },
        {
          id: '3_' + 1,
          pid: '3_' + 0,
          name: '系统管理'
        },
        {
          id: '3_' + 5,
          pid: '3_' + 1,
          name: 'CTI配置'
        },
        {
          id: '3_5-' + 1,
          pid: '3_' + 5,
          name: '热线号码'
        }, {
          id: '3_5-1-' + 1,
          pid: '3_5-' + 1,
          name: '编辑'
        }, {
          id: '3_5-1-' + 2,
          pid: '3_5-' + 1,
          name: '时间定义'
        },
        {
          id: '3_5-' + 2,
          pid: '3_' + 5,
          name: '技能组'
        }, {
          id: '3_5-2-' + 1,
          pid: '3_5-' + 2,
          name: '添加'
        }, {
          id: '3_5-2-' + 2,
          pid: '3_5-' + 2,
          name: '编辑'
        }, {
          id: '3_5-2-' + 3,
          pid: '3_5-' + 2,
          name: '删除'
        }, {
          id: '3_5-2-' + 4,
          pid: '3_5-' + 2,
          name: '分配'
        },
        {
          id: '3_5-' + 3,
          pid: '3_' + 5,
          name: 'IVR设置'
        },
        {
          id: '3_5-3-' + 1,
          pid: '3_5-' + 3,
          name: '添加'
        },
        {
          id: '3_5-3-' + 2,
          pid: '3_5-' + 3,
          name: '配置'
        },
        {
          id: '3_5-3-' + 3,
          pid: '3_5-' + 3,
          name: '删除'
        },
        {
          id: '3_5-3-' + 4,
          pid: '3_5-' + 3,
          name: '编辑'
        },
        {
          id: '3_5-3-' + 5,
          pid: '3_5-' + 3,
          name: '复制流程'
        },
        {
          id: '3_5-' + 4,
          pid: '3_' + 5,
          name: '语音文件'
        }, {
          id: '3_5-4-' + 1,
          pid: '3_5-' + 4,
          name: '添加'
        }, {
          id: '3_5-4-' + 2,
          pid: '3_5-' + 4,
          name: '编辑'
        }, {
          id: '3_5-4-' + 3,
          pid: '3_5-' + 4,
          name: '删除'
        }, {
          id: '3_5-4-' + 4,
          pid: '3_5-' + 4,
          name: '播放'
        }, {
          id: '3_5-4-' + 5,
          pid: '3_5-' + 4,
          name: '下载'
        },
        {
          id: '3_5-' + 5,
          pid: '3_' + 5,
          name: 'VIP管理'
        }, {
          id: '3_5-5-' + 1,
          pid: '3_5-' + 5,
          name: '添加'
        }, {
          id: '3_5-5-' + 2,
          pid: '3_5-' + 5,
          name: '编辑'
        }, {
          id: '3_5-5-' + 3,
          pid: '3_5-' + 5,
          name: '删除'
        },
        {
          id: '3_' +12,
          pid: '3_' + 1,
          name: '会话配置'
        },

        // {
        //   id: '3_12-1-' + 7,
        //   pid: '3_12-' + 1,
        //   name: '绑定小程序'
        // },
        {
          id: '3_12-' + 3,
          pid: '3_' + 12,
          name: '导航菜单'
        }, {
          id: '3_12-3-' + 1,
          pid: '3_12-' + 3,
          name: '添加导航'
        },
        {
          id: '3_12-3-' + 5,
          pid: '3_12-' + 3,
          name: '添加子导航'
        },
         {
          id: '3_12-3-' + 2,
          pid: '3_12-' + 3,
          name: '编辑'
        }, {
          id: '3_12-3-' + 3,
          pid: '3_12-' + 3,
          name: '删除'
        },
        // {
        //   id: '3_12-3-' + 4,
        //   pid: '3_12-' + 3,
        //   name: '分配'
        // },
         {
          id: '3_12-' + 2,
          pid: '3_' + 12,
          name: '黑名单'
        },
         {
          id: '3_12-2-' + 1,
          pid: '3_12-' + 2,
          name: '添加'
        },
         {
          id: '3_12-2-' + 2,
          pid: '3_12-' + 2,
          name: '导入'
        },
         {
          id: '3_12-2-' + 3,
          pid: '3_12-' + 2,
          name: '导出'
        },
         {
          id: '3_12-2-' + 4,
          pid: '3_12-' + 2,
          name: '批量删除'
        },
         {
          id: '3_12-2-' + 5,
          pid: '3_12-' + 2,
          name: '编辑'
        },
         {
          id: '3_12-2-' + 6,
          pid: '3_12-' + 2,
          name: '删除'
        },
        {
          id: '3_12-' + 1,
          pid: '3_' + 12,
          name: '渠道管理'
        },
        {
          id: '3_12-1-' + 1,
          pid: '3_12-' + 1,
          name: '代码'
        },
        {
          id: '3_12-1-' + 2,
          pid: '3_12-' + 1,
          name: '编辑'
        },
        {
          id: '3_12-1-' + 3,
          pid: '3_12-' + 1,
          name: '删除'
        },
        {
          id: '3_12-1-' + 4,
          pid: '3_12-' + 1,
          name: '自定义菜单'
        },
        {
          id: '3_12-1-' + 5,
          pid: '3_12-' + 1,
          name: '添加'
        },
        {
          id: '3_12-1-' + 6,
          pid: '3_12-' + 1,
          name: '绑定公众号'
        },
        {
          id: '3_12-' + 5,
          pid: '3_' + 12,
          name: '参数配置'
        }, {
          id: '3_12-5-' + 1,
          pid: '3_12-' + 5,
          name: '保存'
        },
        // 工单配置
        {
          id: '3_d',
          pid: '3_1',
          name: '工单配置'
        },{
          id: '3_d-1',
          pid: '3_d',
          name: '工单服务组'
        },{
          id: '3_d-1-1',
          pid: '3_d-1',
          name: '添加服务组'
        },{
          id: '3_d-1-2',
          pid: '3_d-1',
          name: '添加子服务组'
        },{
          id: '3_d-1-3',
          pid: '3_d-1',
          name: '编辑'
        },{
          id: '3_d-1-4',
          pid: '3_d-1',
          name: '删除'
        },{
          id: '3_d-2',
          pid: '3_d',
          name: '工单扩展表单'
        },{
          id: '3_d-2-1',
          pid: '3_d-2',
          name: '保存'
        },{
          id: '3_d-3',
          pid: '3_d',
          name: '流程触发器'
        },{
          id: '3_d-3-1',
          pid: '3_d-3',
          name: '添加'
        },{
          id: '3_d-3-2',
          pid: '3_d-3',
          name: '启用'
        },{
          id: '3_d-3-3',
          pid: '3_d-3',
          name: '编辑'
        },{
          id: '3_d-3-4',
          pid: '3_d-3',
          name: '删除'
        },{
          id: '3_d-4',
          pid: '3_d',
          name: 'SLA'
        },{
          id: '3_d-4-1',
          pid: '3_d-4',
          name: '添加'
        },{
          id: '3_d-4-2',
          pid: '3_d-4',
          name: '编辑'
        },{
          id: '3_d-4-3',
          pid: '3_d-4',
          name: '删除'
        },{
          id: '3_d-5',
          pid: '3_d',
          name: '工单参数配置'
        },
        {
          id: '3_' + 2,
          pid: '3_' + 1,
          name: '自定义设置'
        }, {
          id: '3_2-' + 1,
          pid: '3_' + 2,
          name: '添加'
        }, {
          id: '3_2-' + 2,
          pid: '3_' + 2,
          name: '删除'
        }, {
          id: '3_2-' + 3,
          pid: '3_' + 2,
          name: '启用/禁用'
        }, {
          id: '3_2-' + 4,
          pid: '3_' + 2,
          name: '编辑'
        },
        {
          id: '3_' + 9,
          pid: '3_' + 1,
          name: '级联数据设置'
        }, {
          id: '3_9-' + 1,
          pid: '3_' + 9,
          name: '编辑'
        },
        {
          id: '3_' + 6,
          pid: '3_' + 1,
          name: '时间定义'
        }, {
          id: '3_6-' + 1,
          pid: '3_' + 6,
          name: '保存'
        }, {
          id: '3_6-' + 2,
          pid: '3_' + 6,
          name: '添加'
        }, {
          id: '3_6-' + 3,
          pid: '3_' + 6,
          name: '节假日删除'
        }, {
          id: '3_6-' + 4,
          pid: '3_' + 6,
          name: '节假日批量删除'
        },
        {
          id: '3_' + 7,
          pid: '3_' + 1,
          name: '导入批次'
        }, {
          id: '3_7-' + 1,
          pid: '3_' + 7,
          name: '下载'
        }, {
          id: '3_7-' + 2,
          pid: '3_' + 7,
          name: '删除'
        },
        {
          id: '3_' + 8,
          pid: '3_' + 1,
          name: '导出批次'
        }, {
          id: '3_8-' + 1,
          pid: '3_' + 8,
          name: '下载'
        }, {
          id: '3_8-' + 2,
          pid: '3_' + 8,
          name: '删除'
        },
        {
          id: '3_' + 11,
          pid: '3_' + 1,
          name: '黑白名单'
        },{
          id: '3_11-' + 1,
          pid: '3_' + 11,
          name: '添加'
        },{
          id: '3_11-' + 2,
          pid: '3_' + 11,
          name: '导入号码'
        },{
          id: '3_11-' + 3,
          pid: '3_' + 11,
          name: '导出号码'
        },{
          id: '3_11-' + 4,
          pid: '3_' + 11,
          name: '批量删除'
        },{
          id: '3_11-' + 5,
          pid: '3_' + 11,
          name: '启用'
        },{
          id: '3_11-' + 6,
          pid: '3_' + 11,
          name: '禁用'
        },{
          id: '3_11-' + 7,
          pid: '3_' + 11,
          name: '编辑'
        },{
          id: '3_11-' + 8,
          pid: '3_' + 11,
          name: '删除'
        },
        {
          id: '3_12-' + 4,
          pid: '3_' + 1,
          name: '快捷回复'
        }, {
          id: '3_12-4-' + 1,
          pid: '3_12-' + 4,
          name: '添加类目'
        }, {
          id: '3_12-4-' + 2,
          pid: '3_12-' + 4,
          name: '编辑类目'
        }, {
          id: '3_12-4-' +3,
          pid: '3_12-' + 4,
          name: '删除类目'
        }, {
          id: '3_12-4-' + 4,
          pid: '3_12-' + 4,
          name: '添加话术'
        },
        {
          id: '3_12-4-' + 5,
          pid: '3_12-' + 4,
          name: '编辑话术'
        },
        {
          id: '3_12-4-' + 6,
          pid: '3_12-' + 4,
          name: '删除话术'
        },
        {
          id: '3_' + 3,
          pid: '3_' + 1,
          name: '基本配置'
        },
        {
          id: '3_' + 4,
          pid: '3_' + 1,
          name: '操作日志'
        },
        {
          id: '3_' + 10,
          pid: '3_' + 1,
          name: '已删除客户'
        }, {
          id: '3_10-' + 1,
          pid: '3_' + 10,
          name: '批量删除'
        }, {
          id: '3_10-' + 2,
          pid: '3_' + 10,
          name: '批量还原'
        }, {
          id: '3_10-' + 3,
          pid: '3_' + 10,
          name: '还原'
        }, {
          id: '3_10-' + 4,
          pid: '3_' + 10,
          name: '删除'
        },
        {
          id: '9_' + 1,
          pid: '9_' + 0,
          name: '用户管理'
        },
        {
          id: '9_' + 2,
          pid: '9_' + 1,
          name: '角色管理'
        }, {
          id: '9_2-' + 1,
          pid: '9_' + 2,
          name: '添加'
        }, {
          id: '9_2-' + 2,
          pid: '9_' + 2,
          name: '编辑'
        }, {
          id: '9_2-' + 3,
          pid: '9_' + 2,
          name: '删除'
        },
        {
          id: '9_' + 3,
          pid: '9_' + 1,
          name: '员工管理'
        }, {
          id: '9_3-' + 1,
          pid: '9_' + 3,
          name: '添加'
        }, {
          id: '9_3-' + 2,
          pid: '9_' + 3,
          name: '导入'
        }, {
          id: '9_3-' + 3,
          pid: '9_' + 3,
          name: '导出'
        }, {
          id: '9_3-' + 4,
          pid: '9_' + 3,
          name: '批量修改'
        }, {
          id: '9_3-' + 5,
          pid: '9_' + 3,
          name: '批量删除'
        }, {
          id: '9_3-' + 6,
          pid: '9_' + 3,
          name: '编辑'
        }, {
          id: '9_3-' + 7,
          pid: '9_' + 3,
          name: '删除'
        },
        {
          id: '9_3-' + 8,
          pid: '9_' + 3,
          name: '归属地'
        },
        {
          id: '9_' + 4,
          pid: '9_' + 1,
          name: '部门管理'
        }, {
          id: '9_4-' + 1,
          pid: '9_' + 4,
          name: '添加子部门'
        }, {
          id: '9_4-' + 2,
          pid: '9_' + 4,
          name: '编辑'
        }, {
          id: '9_4-' + 3,
          pid: '9_' + 4,
          name: '删除'
        },
        {
          id: '9_' + 5,
          pid: '9_' + 1,
          name: '通讯录'
        }, {
          id: '9_5-' + 1,
          pid: '9_' + 5,
          name: '添加'
        }, {
          id: '9_5-' + 2,
          pid: '9_' + 5,
          name: '导入'
        }, {
          id: '9_5-' + 3,
          pid: '9_' + 5,
          name: '导出'
        },{
          id: '9_5-' + 4,
          pid: '9_' + 5,
          name: '批量删除'
        }, {
          id: '9_5-' + 5,
          pid: '9_' + 5,
          name: '编辑'
        },{
          id: '9_5-' + 6,
          pid: '9_' + 5,
          name: '删除'
        },{
          id: '9_' + 6,
          pid: '9_' + 1,
          name: '公告管理'
        },{
          id: '9_6-' + 1,
          pid: '9_' + 6,
          name: '添加'
        },{
          id: '9_6-' + 2,
          pid: '9_' + 6,
          name: '编辑'
        },{
          id: '9_6-' + 3,
          pid: '9_' + 6,
          name: '删除'
        },{
          id: '9_6-' + 4,
          pid: '9_' + 6,
          name: '查看'
        },{
          id: '9_6-' + 5,
          pid: '9_' + 6,
          name: '发布'
        }

      ],
      sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
    }
  },
  methods: {
    cancel: function () {
      this.$emit('closeInsertPower', false)
    },
    saveRoleInfo: function () {
      if (!this.roleName) {
        this.$Modal.info({
          title: '提示',
          content: '请输入角色名称!'
        })
        return false
      }
      let zTree = $.fn.zTree.getZTreeObj('roletree')
      let changedNodes = zTree.getCheckedNodes(true) //获取选中的节点
      if (changedNodes.length == 0) {
        this.$Modal.info({
          title: '提示',
          content: '请选择角色的操作权限!'
        })
        return false
      }
      let permissionListStr = []
      for (let i = 0; i < changedNodes.length; i++) {
        permissionListStr.push(changedNodes[i].id)
      }
      let journalType = '用户管理=>角色管理=>角色编辑'
      let menuId = '9_2-2'
      if (!this.roleId) {
        journalType = '用户管理=>角色管理=>角色添加'
        menuId = '9_2-1'
      }
      let param = {
        permissionListStr: permissionListStr.toString(),
        roleName: this.roleName,
        roleDesc: this.roleDesc,
        queues: this.queues.toString(),
        id: this.roleId,
        journalType: journalType,
        menuId: menuId
      }
      let that = this
      this.spinValue = '正在保存中...'
      this.spinShow = true
      this.$http.post('role/doSave.json', param).then(function (res) {
        let result = res.data.flag
        that.spinShow = false
        if (result != '666') {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          })
          return false
        }
        that.$Modal.info({
          title: '提示',
          content: '权限保存成功'
        })
        that.$emit('closeInsertPower', true)
        that.customList = res.data.obj
      })
    },
    initSearch: function () {
      let that = this
      this.spinValue = '正在加载中...'
      this.spinShow = true
      let param = {
        id: this.roleId,
        journalType: 'null',
        menuId: 'null'
      }
      this.$http.post('role/toIndex.json', param).then(function (res) {
        let result = res.data.flag
        that.spinShow = false
        if (result != '666') {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          })
          return false
        }
        that.queues = []
        let list = res.data.obj.list.content
        let menuList = res.data.obj.menuList
        for (let k = 0; k < menuList.length; k++) {
          let id = menuList[k]
          for (let i = 0; i < that.inspectTreeData.length; i++) {
            let checkId = that.inspectTreeData[i].id
            if (checkId == id) {
              that.inspectTreeData[i].checked = true
            }
          }
        }
        that.initTree('roletree')
        if (that.searchId) {
          that.roleName = list[0].roleName
          that.roleDesc = list[0].roleDesc
          if (list[0].queues) {
            that.queues = list[0].queues.split(',')
          }
        }
      })
    }
  },
  watch: {
    showInsertPower: function () {
      this.model = this.showInsertPower
      this.roleId = this.searchId
      this.spinShow = false
      this.roleName = ''
      this.roleDesc = ''
      let recognize = this.configInfo.aiRecognize
      if (this.showInsertPower) {
        let treeData = []
        for (let i = 0; i < this.inspectTreeData.length; i++) {
          if (this.supportAI === '0') {
            if (this.inspectTreeData[i].id.startsWith('a') || this.inspectTreeData[i].id.startsWith('8_6')) {
              continue
            }
          }else{
            if (recognize + '' !== '1' && recognize + '' !== '2') {
              if (this.inspectTreeData[i].id === '8_6-2') {
                continue
              }
            }
          }
          if(this.sysSupportChat === '0'){
            if ((this.inspectTreeData[i].id.startsWith('3_12') && !this.inspectTreeData[i].id.startsWith('3_12-4')) || this.inspectTreeData[i].id.startsWith('8_2-9') || this.inspectTreeData[i].id.startsWith('8_2-10')) {
              continue
            }
          }
          if("0" == this.sysSupportWorkOrder){
            if(this.inspectTreeData[i].pid.startsWith('b_') || this.inspectTreeData[i].id.startsWith('8_7') || this.inspectTreeData[i].id.startsWith('3_d') || this.inspectTreeData[i].id.startsWith('7_3')){
              continue
            }
          }
          // 在线客服
          if(this.sysSupportChat === '0' && "0" == this.sysSupportWorkOrder){
            if (this.inspectTreeData[i].id.startsWith('3_12-4')) {
              continue
            }
          }
          this.inspectTreeData[i].checked = false
          treeData.push(this.inspectTreeData[i])
        }
        this.inspectTreeData = treeData
        this.getQueue('0')
        this.initSearch()
      }
      this.title = '添加角色'
      if (this.searchId) {
        this.title = '编辑角色'
      }
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/userManagement/InsertPowerPop.vue